export default __webpack_public_path__ + "static/media/san-rafael-16.6791a083.jpg";